import BaseService from './BaseService'

export class ItemService extends BaseService {
  // eslint-disable-next-line no-useless-constructor
  constructor (axios) {
    super(axios)
  }
  loadFullInfo (itemIds) {
    var size = 5
    var pages = itemIds.length / 5
    var requests = []
    for (let index = 0; index < pages; index++) {
      var data = itemIds.slice(index * size, (index + 1) * size)
      requests.push(this.requestItemDetails(data))
    }
    return Promise.all(requests).then(res => {
      var tmpItemList = []
      res.forEach(response => {
        const { content = [] } = response
        content.forEach(tmpItem => {
          var item = this.handlerItem(tmpItem)
          tmpItemList.push(item)
        })
      })
      return tmpItemList
    })
  }
  handlerItem (tmpItem) {
    if (tmpItem.imgs === undefined) tmpItem.imgs = []
    const Item = { disabled: false };
    ({ basicUnit: Item.basicUnit, content: Item.desc, name: Item.name, id: Item.id, inventory: Item.inventory, expiryTime: Item.expiryTime,
      largeScale: Item.largeScale, transferPrice: Item.showPrice, businessPromotionDto: Item.promotion = {},
      generalName: Item.generalName, quantity: Item.quantity, quotationPrice: Item.quotationPrice,
      licenseNumber: Item.licenseNumber, generalName: tmpItem.generalName, calcuPrice: Item.instructPrice, title2: Item.standard,
      shopName: Item.shopName, title1: Item.commonName, imgs: [Item.image, ...Item.otherImg], id: Item.id,
      manufacturer: Item.manufacturer, standard: Item.norm } = tmpItem)
    Item.promotionType = Item.promotion.type || -1
    Item.promotionDesc = Item.promotion.description || '暂无活动'
    if (Item.inventory <= 0) Item.disabled = true
    switch (Item.promotionType) {
      case 1:
        Item.promotionDesc = '买赠'
        break
      case 2:
        Item.promotionDesc = '特价'
        break
    }
    if (Item.promotionType === 2 && Item.promotion.businessPromotionItemDtos !== undefined) {
      const rules = Item.promotion.businessPromotionItemDtos || []
      var activePrice
      rules.forEach(item => {
        if (item.itemId === Item.id) {
          activePrice = item.tjPrice
          Item.promotion.limitNum = item.limitNum
          Item.promotion.least = item.least
        }
      })
      Item.promotion.activePrice = activePrice || Item.showPrice
    }
    if (Item.expiryTime !== undefined && Item.expiryTime !== null) {
      Item.expiryTime = Item.expiryTime.slice(0, 7)
    }
    if (Item.image === undefined) Item.image = 'http://lyly360.oss-cn-shenzhen.aliyuncs.com/filenZpmQSDwtJ.jpg-ly.jpg'
    return Item
  }
  requestItemDetails (data) {
    const url = '/hy-sb-item/item/purchaseGetFullInfo'
    const rs = this.httpTool.post(url, {
      itemIds: data
    })
    console.log(rs, 'rs test')
    return rs
  }
  dealItemList (list) {
    const items = []
    list.forEach(item => {
      const tmpItem = { checked: true };
      // name - 名称 title1 - 通用名
      ({ id: tmpItem.id, basicUnit: tmpItem.basicUnit, licenseNumber: tmpItem.licenseNumber, title1: tmpItem.commonName,
        manufacturer: tmpItem.manufacturer, largeScale: tmpItem.largeScale, shopName: tmpItem.shopName,
        name: tmpItem.name, title2: tmpItem.norm, calcuPrice: tmpItem.oldPrice, shopId: tmpItem.shopId,
        imgs: [tmpItem.image, ...tmpItem.otherImg] } = item)
      if (tmpItem.oldPrice !== undefined) {
        tmpItem.oldPrice = tmpItem.oldPrice.toFixed(2)
      }
      tmpItem.expiryTime = '加载中'
      tmpItem.inventory = '加载中'
      tmpItem.oldPrice = '加载中'
      tmpItem.showPrice = '加载中'
      tmpItem.num = 1
      items.push(tmpItem)
    })
    return items
  }
  loadItems (data) {
    const url = '/hy-sb-item/item/pageSearchAllItems'
    return this.httpTool.request({ url: url,
      data: data,
      method: 'post' })
      .then((response) => {
        let items = []
        if (response.code === '0') {
          const { content: { count, index, pages, size, list = [] }} = response
          var pageInfo = { count: count, index: index, pages: pages, size: size }
          items = this.dealItemList(list)
        }
        return { items: items, pageInfo: pageInfo }
      })
      .catch((error) => {
        console.log(error)
        return null
      })
  }
  // 加载区域
  loadRegions (type) {
    const url = '/hy-sb-system/wordlib/findType'
    return this.httpTool.get(url, { params: { type: type }})
      .then((response) => {
        const regions = []
        const { content = [] } = response
        content.forEach(region => {
          const regionValue = {};
          ({ value: regionValue.name, code: regionValue.id } = region)
          regions.push(regionValue)
        })
        return regions
      })
      .catch((error) => {
        console.log(error)
        return null
      })
  }
  // 加载商品的供应商
  loadShops (searchText) {
    const url = 'hy-sb-shop/shop/getShopsBySearch'
    return this.httpTool
      .get(url, { params: { search: searchText }})
      .then(response => {
        const { content = [] } = response
        return content
      })
      .catch(error => {
        console.log(error)
        return null
      })
  }
  // 加载该商品的生产厂家
  loadManufature (searchText) {
    const url = '/hy-sb-item/item/getManufacturerOfItemBySearch'
    return this.httpTool
      .get(url, { params: { search: searchText }})
      .then(response => {
        const { content = [] } = response
        return content
      })
      .catch(error => {
        console.log(error)
        return null
      })
  }
  // 加载改商品规格
  loadNorm (searchText) {
    const url = '/hy-sb-item/item/getTitle2OfItemBySearch'
    return this.httpTool
      .get(url, { params: { search: searchText }})
      .then(response => {
        const { content = [] } = response
        return content
      })
      .catch(error => {
        console.log(error)
        return null
      })
  }

  loadIndexItem (data) {
    // 获取首页展示商品
    const url = '/hy-sb-shop/floorItem/floorItemList'
    return this.httpTool
      .get(url, { params: data })
      .then(response => {
        const { content = [] } = response
        var tmpItems = this.dealItemList(content)
        console.log('处理后的列表_____', tmpItems)
        return tmpItems
      })
      .catch(error => {
        console.log(error)
        return null
      })
  }
  loadQuotationItem (data) {
    // 获取报价单中的商品列表
    const url = '/hy-sb-item/quotationItem/findQuotationItem'
    return this.httpTool.request({ url: url,
      data: data,
      method: 'post' })
      .then((response) => {
        const { count, index, pages, size, list = [] } = response.content
        const pageInfo = { count: count, index: index, pages: pages, size: size }
        const items = []
        if (response.code === '0') {
          list.forEach(item => {
            var tmpItem = this.handlerItem(item)
            items.push(tmpItem)
          })
        }
        return { items: items, pageInfo: pageInfo }
      })
      .catch(error => {
        console.log(error)
        return null
      })
  }
  loadQuotationsId (data) {
    // 获取查询结果中报价单的单号
    const url = 'hy-sb-item/inquerySheet/findInquerySheetIdsByCreateTime'
    return this.httpTool
      .get(url, data)
      .then(response => {
        console.log(response)
        return response
      })
      .catch(error => {
        console.log(error)
        return null
      })
  }
  loadQuotation (data) {
    // 上传报价单
    const url = 'hy-sb-item/inquerySheet/uploadInquerySheet'
    const config = {
      headers: { 'Content-Type': 'multipart/form-data' }
    }
    return this.httpTool
      .post(url, data, config)
      .then(response => {
        return response
      })
      .catch(error => {
        console.log(error)
        return null
      })
  }
  exportQuotationResult (data) {
    const url = 'hy-sb-item/quotationItem/exportQuotationItem'
    return this.httpTool
      .get(url, { params: data })
      .then(response => {
        console.log(response)
        return response
      })
      .catch(error => {
        console.log(error)
        return null
      })
  }
  loadgeneralName (data) {
    // 获取商品通用名
    const url = 'hy-sb-item/quotationItem/findQuotationItemName'
    return this.httpTool
      .get(url, data)
      .then(response => {
        console.log(response)
        return response
      })
      .catch(error => {
        console.log(error)
        return null
      })
  }
  loadManufacturerItem (data) {
    // 根据品牌厂家查询商品
    const url = 'hy-sb-item/manufacturer/searchItem'
    return this.httpTool
      .post(url, data)
      .then(response => {
        const { count, index, pages, size, list = [] } = response.content
        const pageInfo = { count: count, index: index, pages: pages, size: size }
        const items = []
        if (response.code === '0') {
          list.forEach(item => {
            var tmpItem = this.handlerItem(item)
            console.log(item, tmpItem, 'after handleer')
            items.push(tmpItem)
          })
        }
        return { items: items, pageInfo: pageInfo }
      })
      .catch(error => {
        console.log(error)
        return null
      })
  }
  loadUnionItem (data) {
    // 分页查询楼层商品
    const url = 'hy-sb-shop/floorItem/findFloorItem'
    return this.httpTool
      .post(url, data)
      .then(response => {
        const { content: { count, index, pages, size, list = [] }} = response
        const pageInfo = { count: count, index: index, pages: pages, size: size }
        const items = []
        if (response.content) {
          list.forEach(item => {
            var tmpItem = this.handlerItem(item)
            items.push(tmpItem)
          })
        }
        return { items: items, pageInfo: pageInfo }
      })
      .catch(error => {
        console.log(error)
        return null
      })
  }
}
